import { useQuery } from '@tanstack/react-query';
import type { Discount, DiscountTypeMetaID, Reward } from '../types';
import { useDiscountsApi } from './use-discounts-api';

export const QK_DISCOUNTS_LIST = () => ['discounts-list'] as const;

// compute template for legacy discounts without one
function calculateRewardTemplate(discount: Discount) {
  if (!discount.template) {
    discount.template = inferTemplateFromRewards(discount.rewards);
  }
  return discount;
}

function inferTemplateFromRewards(rewards: Reward[]): DiscountTypeMetaID {
  if (!rewards || rewards.length === 0) {
    return 'order_level_get_amount_off';
  }

  const first = rewards[0];
  switch (first?.type) {
    case 'product':
      return 'order_level_get_free_product';
    case 'order':
      return 'order_level_get_amount_off';
    case 'shipping':
      return 'order_level_get_shipping_reward';
    case 'cart|productSKU':
      return 'product_level_get_amount_off';
    default:
      return 'order_level_get_amount_off';
  }
}

export function useDiscountsList() {
  const { discountsApi } = useDiscountsApi();

  const query = useQuery({
    queryKey: QK_DISCOUNTS_LIST(),
    queryFn: () => discountsApi.list(),
    select: (data) => data.map(calculateRewardTemplate),
  });

  return {
    ...query,
    data: query.data ?? [],
  };
}
